<template>
    <div class="bg-white w-full h-full">
        <div class="loading flex bg-black/50 flex-row w-full h-full">
            <!-- image container-->
            <div class="w-14 h-full bg-black/50"></div>

            <!-- content -->
            <div class="flex flex-col flex-grow mx-4 my-3 justify-between">
                <div class="bg-black/50 w-2/3 h-3 rounded-full"></div>
                <div class="bg-black/50 w-full h-4 rounded-full"></div>
                <div class="bg-black/50 w-1/3 h-3 rounded-full"></div>
            </div>

            <!-- play button-->
            <div class="flex items-center justify-center mx-4">
                <div class="w-9 h-9 bg-black/50 rounded-full"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MiniPlayerLoadingComponent"
}
</script>

<style scoped>
.loading {
    pointer-events: none;
    opacity: 0.3;
    animation: loading 3s ease-out;
    animation-iteration-count: infinite;
}
@keyframes loading {
    0% {
        opacity: 0.2;
    }
    50% {
        opacity: 0.4;
    }
    100% {
        opacity: 0.2;
    }
}
</style>